module.exports = __webpack_public_path__ + "static/media/Marktheprop.f5f391e5.svg";